import clsx from 'clsx'
import { ComponentType, SVGProps } from 'react'

import { Atoms, atoms } from 'style/atoms.css'

import { sizes } from './BlockIcon.css'

interface Props {
	icon: ComponentType<SVGProps<SVGSVGElement>>
	size?: keyof typeof sizes
	color?: Atoms['color']
	className?: string
}

export const BlockIcon = ({ icon: Icon, size = 'medium', color, className }: Props) => {
	return <Icon className={clsx(sizes[size], atoms({ color }), className)} viewBox="0 0 24 24" />
}
